export const RECRUIT_SAVED_SEARCH_PLACEHOLDER = '제목, 교회/기관/학교 이름, 이메일주소';

export const RECRUIT_SAVED_CHURCH_COLUMN = '교회/기관/학교';

export type RecruitSavedListItem = {
  id?: number | string;
  title: string;
  church: string;
  date: string;
  saveDate?: string;
  saveUser?: string;
  userAccount?: string;
  inquiry?: string;
  source?: string;
  writer?: string;
  link?: string;
  religiousbody?: string;
  location?: string;
  locationDetail?: string;
  address?: string;
  mainpastor?: string;
  mainPastor?: string;
  homepage?: string;
  recruitNum?: string;
  sort?: string;
  school?: string;
  career?: string;
  part?: string;
  partDetail?: string;
  workday?: string;
  workTimeSunDay?: string;
  workTimeWeek?: string;
  dawnPray?: string;
  pay?: string;
  welfare?: string;
  insurance?: string;
  severance?: string;
  applydoc?: string;
  applyhow?: string;
  applytime?: string;
  etcNotice?: string;
  customInput?: string;
};

export const renderPreview = (value: string, maxLength = 40) => {
  if (!value) return '';
  if (value.length > maxLength) return `${value.substring(0, maxLength)}...`;
  return value;
};

export const extractEmail = (inquiry?: string) => {
  if (!inquiry) return '';
  try {
    const parsed = JSON.parse(inquiry);
    return parsed.email || '';
  } catch {
    return '';
  }
};

export type RecruitSavedEditType = 'minister' | 'overseas' | 'church' | 'institute';

export type RecruitInquiryFields = {
  inquiryName: string;
  email: string;
  phone: string;
};

export const parseInquiry = (inquiry?: string): RecruitInquiryFields => {
  if (!inquiry) return { inquiryName: '', email: '', phone: '' };
  try {
    const parsed = JSON.parse(inquiry);
    return {
      inquiryName: parsed.inquiryName || '',
      email: parsed.email || '',
      phone: parsed.phone || '',
    };
  } catch {
    return { inquiryName: '', email: '', phone: '' };
  }
};

export const buildInquiryJson = (fields: RecruitInquiryFields) =>
  JSON.stringify({
    inquiryName: fields.inquiryName,
    email: fields.email,
    phone: fields.phone,
  });

export const formatJsonField = (value?: string) => {
  if (!value) return '';
  try {
    return JSON.stringify(JSON.parse(value), null, 2);
  } catch {
    return value;
  }
};

export const compactJsonField = (value: string) => {
  const trimmed = value.trim();
  if (!trimmed) return '';
  try {
    return JSON.stringify(JSON.parse(trimmed));
  } catch {
    return trimmed;
  }
};
